import { useCallback, useEffect, useState } from 'react';
import axiosInstance from 'utils/axiosInterceptors';
import { TProcurementInvoiceDetails } from 'utils/types';

type TCustomHookProps = {
  id: number | undefined;
  branchDomain: string | undefined;
  paymentStatus: string | undefined;
};

const useFetchInvoice = ({
  id,
  branchDomain,
  paymentStatus
}: TCustomHookProps) => {
  const [invoices, setInvoices] = useState<TProcurementInvoiceDetails[]>([]);

  const fetchInvoice = useCallback(async () => {
    if (!id || !branchDomain) return;

    try {
      const res = await axiosInstance.get(
        `/api/v1/${branchDomain}/procurementInvoices?page=1&pageSize=1000&status=Processed&supplierId=${id}&paymentStatus=${paymentStatus}`
      );
      setInvoices(res.data.data);
    } catch (error) {
      console.error(error);
    }
  }, [branchDomain, id, paymentStatus]);

  useEffect(() => {
    fetchInvoice();
  }, [fetchInvoice]);

  return { invoices, fetchInvoice };
};

export default useFetchInvoice;
